import { render, staticRenderFns } from "./stepUi.vue?vue&type=template&id=53aa6133&scoped=true&"
import script from "./stepUi.vue?vue&type=script&lang=js&"
export * from "./stepUi.vue?vue&type=script&lang=js&"
import style0 from "./stepUi.vue?vue&type=style&index=0&id=53aa6133&scoped=true&lang=scss&"
import style1 from "./stepUi.vue?vue&type=style&index=1&id=53aa6133&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aa6133",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53aa6133')) {
      api.createRecord('53aa6133', component.options)
    } else {
      api.reload('53aa6133', component.options)
    }
    module.hot.accept("./stepUi.vue?vue&type=template&id=53aa6133&scoped=true&", function () {
      api.rerender('53aa6133', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/templateMgr/components/maintenanceRecordType/stepUi.vue"
export default component.exports